var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatcoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2421_849",
    transform: "scale(0.047619)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2421_849",
    width: 21,
    height: 21,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAABrUlEQVQ4EZVVPU5CQRBeQoyGoGAMRpyXaGVNYm/oNbGl0sb+6QH0ABZCpZ2SWBsvoNb7MAYvYOACHmEz5htYXHZ5C5BMZmfe7Lfzj1I5P+5Rw+gkNZqeTEZ9kyUsHLJOUnzPuRqquV+tmh61RyAAilCP2rAPURwNfyZNo2kQBfIf0TTAPQfm/yiA/oUl5CAdEvKyHvoPwmM3FUZTJxby+32NGwcrDB6zA47ELlX2X/Xk06M1Vkrx2XEpDpolLGkwmi5jr/+87gjg3VVFOOSYPfCUyajrGv2+7fLHQ21C5ycl3q8XRQZPW+XJN9jB3r0PPIB+u0rkDaEuSmGeqa9cQP/8eL3Je/XilCeVcoGh921dOfD063mbm4erQtX1AoOsDO7rYO8CIvIgpyjEzcUG24rj7JPtBOjDwiGnOdUHaF4LQZ/3Tao/q09tG4WhjZaLLWZY+XGfYgL8iYLxvGK83G6F7WQnCqDj2R9OJzyy8ryJk3uahlOzL8BYe7OMF9QFW0qWADwe7dPlPIaH8/4FxqmIbq1JRJo6QcjWw1lcukLaDbvBjjI4ddE2Me/+ANvytn9k9wypAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatcoin);
export default __webpack_public_path__ + "static/media/avatcoin.b1e397ddb30b6d3a8b871b81736aecb7.svg";
export { ForwardRef as ReactComponent };